import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { launchTargetPath } from '@/app/launchTargetPath'

interface LaunchParams {
  targetURL?: string
}

interface LaunchQueue {
  setConsumer: (consumer: (params: LaunchParams) => void) => void
}

/**
 * Com `launch_handler: focus-existing`, um atalho do ícone só foca a janela aberta.
 * Aqui o app lê o destino do atalho e navega sem recarregar, sem perder o que estava na tela.
 */
export function LaunchQueueHandler() {
  const navigate = useNavigate()

  useEffect(() => {
    const queue = (window as Window & { launchQueue?: LaunchQueue }).launchQueue
    queue?.setConsumer((params) => {
      const path = launchTargetPath(params.targetURL, window.location.origin)
      if (path && path !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
        navigate(path)
      }
    })
  }, [navigate])

  return null
}
